import { render, staticRenderFns } from "./DonationModal.vue?vue&type=template&id=70085055&scoped=true&"
import script from "./DonationModal.vue?vue&type=script&lang=js&"
export * from "./DonationModal.vue?vue&type=script&lang=js&"
import style0 from "./DonationModal.vue?vue&type=style&index=0&id=70085055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70085055",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Donation: require('/home/bitrix/frontend/components/home/Donation.vue').default})
